import { SvgIconProps } from "@mui/material";

// A tall main pane on the left, a 3x3 grid of small panes on the right.
export const OneVertPlusNineIcon = (props: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <rect x="2" y="2" width="9" height="20" rx="1.5" />
    <rect x="13" y="2" width="2.3" height="6" rx="0.6" />
    <rect x="16.3" y="2" width="2.3" height="6" rx="0.6" />
    <rect x="19.6" y="2" width="2.3" height="6" rx="0.6" />
    <rect x="13" y="9" width="2.3" height="6" rx="0.6" />
    <rect x="16.3" y="9" width="2.3" height="6" rx="0.6" />
    <rect x="19.6" y="9" width="2.3" height="6" rx="0.6" />
    <rect x="13" y="16" width="2.3" height="6" rx="0.6" />
    <rect x="16.3" y="16" width="2.3" height="6" rx="0.6" />
    <rect x="19.6" y="16" width="2.3" height="6" rx="0.6" />
  </svg>
);
